import { useMutation, useQuery } from 'react-query'
import {
  getSSCCLabelDownload,
  getSSCCLabelTable,
  getSgtinTable,
  getSsccTable,
  traceByBarcode,
  downloadSsccLabels,
  downloadSgtinLabels,
  getPackingDetails,
  checkLabelEligibility
} from '../api-services/labels'

const labelKey = 'sscc-label-table'
const sgtinTableKey = 'sgtin-label-table'
const ssccTableKey = 'sscc-label-table'

const useGetSSCCLabelTable = params => {
  const response = useQuery({
    queryKey: [labelKey, params],
    queryFn: () => getSSCCLabelTable(params),
    keepPreviousData: true
  })

  return response
}

const useDownloadSSCCLabel = mutationOptions => {
  const mutation = useMutation({
    mutationFn: payload => getSSCCLabelDownload(payload),
    onSuccess: data => {
      if (mutationOptions.onSuccess) {
        mutationOptions.onSuccess(data)
      }
    },
    onError: error => {
      if (mutationOptions.onError) {
        mutationOptions.onError(error)
      }
    }
  })

  return {
    download: mutation.mutate,
    isLoading: mutation.isPending,
    ...mutation
  }
}

const useGetSgtinTable = async () => {
  const response = useQuery({
    queryFn: () => getSgtinTable(),
    queryKey: [sgtinTableKey]
  })
  return {
    ...response
  }
}

const useGetSsccTable = async () => {
  const response = useQuery({
    queryFn: () => getSsccTable(),
    queryKey: [ssccTableKey]
  })
  return {
    ...response
  }
}

export {
  useGetSSCCLabelTable,
  useDownloadSSCCLabel,
  useGetSgtinTable,
  useGetSsccTable
}
